import { render, staticRenderFns } from "./Cliente_editar.vue?vue&type=template&id=445e0f0e&scoped=true"
import script from "./Cliente_editar.vue?vue&type=script&lang=js"
export * from "./Cliente_editar.vue?vue&type=script&lang=js"
import style0 from "./Cliente_editar.vue?vue&type=style&index=0&id=445e0f0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e0f0e",
  null
  
)

export default component.exports